var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"init-content"}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),(_vm.errShow)?_c('div',{staticClass:"text-center",staticStyle:{"padding-top":"30px"}},[_c('button',{staticClass:"btn btn-warning btn-lg",attrs:{"type":"button"},on:{"click":function($event){_vm.quit()},"touchstart":function($event){_vm.quit()}}},[_vm._v("退出应用")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7632f23a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/init.vue
// module id = fMF4
// module chunks = 1